const hamburger = () => {
    var hamburger = $('#hamburger'),
        menu = $('#menu');
        hamburger.on('click', function(){
            $(this).toggleClass('is-active');
            menu.toggleClass('open');
            if( menu.hasClass('open') ){
                menu.addClass('slideInDown').removeClass('slideOutUp');
            }else{
                menu.addClass('slideOutUp').removeClass('slideInDown');
            }
        });
 }

 module.exports = {
     hamburger, 
 };